module.exports = __webpack_public_path__ + "img/services-2.35f56362.jpg";